import { render, staticRenderFns } from "./OrderReportListDetail.vue?vue&type=template&id=37ae9a52"
import script from "./OrderReportListDetail.vue?vue&type=script&lang=ts"
export * from "./OrderReportListDetail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../qraved-ordering-backoffice/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports